import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Sem isto, qualquer erro de render derruba a arvore inteira e sobra uma tela
 * preta sem explicacao. Aqui pelo menos aparece o que quebrou e um botao para
 * recomecar.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[callzone] erro de render:', error, info.componentStack);
  }

  override render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="onboarding">
        <div className="onboarding-card">
          <h1>Algo quebrou</h1>
          <p className="sub">
            A interface encontrou um erro e parou. Nada foi perdido no servidor — recarregar
            costuma resolver.
          </p>
          <div className="error-box" style={{ whiteSpace: 'pre-wrap', fontSize: 11 }}>
            {error.message}
          </div>
          <button className="btn full" onClick={() => window.location.reload()}>
            Recarregar
          </button>
          <div style={{ textAlign: 'center', marginTop: 12 }}>
            <button
              className="link-btn"
              onClick={() => {
                // Ultimo recurso: limpa a sessao e volta para a tela de acesso.
                try {
                  localStorage.removeItem('callzone:credentials');
                } catch {
                  // ignora
                }
                window.location.reload();
              }}
            >
              sair e comecar de novo
            </button>
          </div>
        </div>
      </div>
    );
  }
}
